import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';
import { toast } from "react-toastify";

export const useCloseBatch = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (batchId: string) => {
            const res = await apiClient.patch(ENDPOINTS.BATCHES.CLOSE_BATCH(batchId));
            return res.data;
        },
        onSuccess: (data, batchId) => {
            toast.success(data?.message || "Batch closed successfully!");
            queryClient.invalidateQueries({ queryKey: ["get_batch_by_id", batchId] });
            queryClient.invalidateQueries({ queryKey: ["get_all_batches"] });
        },
        onError: (err: any) => {
            toast.error(err?.response?.data?.message || err?.message || "Failed to close batch");
        },
    });
};
